import { Buffer } from 'buffer';

const btoa = (str: string) =>
  Buffer.isBuffer(str)
    ? str.toString("base64")
    : Buffer.from(str.toString(), "binary").toString("base64");

const atob = (str: string) => Buffer.from(str, "base64").toString("binary");

export const Base64 = {
  encode: (str?: string | null) =>
    str != "" && str != null && str != " " ? btoa(unescape(encodeURIComponent(str))) : "",
  decode: (str?: string | null) =>
    str != "" && str != null && str != " " ? decodeURIComponent(escape(atob(str))) : ""
};
